/**
 * Container component - контейнер с max-width для секций
 */

// Пресеты ширины
const maxWidthClasses = {
  sm: 'max-w-2xl',
  md: 'max-w-4xl',
  lg: 'max-w-6xl',
  xl: 'max-w-7xl',
  full: 'max-w-full',
};

// Пресеты padding
const paddingClasses = {
  none: '',
  sm: 'px-4',
  md: 'px-4 md:px-6',
  lg: 'px-4 md:px-6 lg:px-8',
};

export default function Container({
  children,
  maxWidth = 'lg',   // sm, md, lg, xl, full
  padding = 'md',    // none, sm, md, lg
  centered = true,   // mx-auto
  className = '',
  style,
  ...props
}) {
  const classes = [
    maxWidthClasses[maxWidth] || maxWidthClasses.lg,
    paddingClasses[padding] || paddingClasses.md,
    centered ? 'mx-auto' : '',
    className,
  ].filter(Boolean).join(' ');

  return (
    <div className={classes} style={style} {...props}>
      {children}
    </div>
  );
}

Container.maxWidths = Object.keys(maxWidthClasses);
Container.paddings = Object.keys(paddingClasses);
